import FileInput from 'components/form/FileInput'
import Button from 'components/form/Button'
import * as PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { fail } from 'features/toast/Toast'
import Icon from 'components/Icon'
import classNames from 'classnames'
import { isEmpty } from 'utils'
import NoneAnchor from 'components/NoneAnchor'
import uploadDocument from '../thunk/uploadDocument'
import { deleteDocumentFile } from '../channelAddSlice'
import { useDispatch } from 'react-redux'
import ErrorText from '../../../../components/form/ErrorText'
import { DOCUMENT_FILE_SIZE_LIMIT } from '../../../document/documentAddSlice'

export const DocumentItem = ({ document, isEditable }) => {
  const dispatch = useDispatch()
  const [error, setError] = useState(false)
  const [open, setOpen] = useState(false)
  const [isUploading, setIsUploading] = useState(false)

  useEffect(() => {
    setOpen(!isEmpty(document.files))
  }, [document.files])

  const handleFileChange = async files => {
    setIsUploading(true)
    const [file] = files
    if (file.size > DOCUMENT_FILE_SIZE_LIMIT) {
      setError(true)
      setOpen(true)
    } else {
      setError(false)
      try {
        await dispatch(
          uploadDocument({
            id: document.id,
            file,
          })
        )
        setOpen(true)
      } catch (e) {
        fail('파일 업로드에 실패하였습니다.')
      }
    }
    setIsUploading(false)
  }
  const handleFileDelete = ({ id, path }) =>
    dispatch(
      deleteDocumentFile({
        id,
        path,
      })
    )

  return (
    <li
      className={classNames({
        open,
        file_on: document.files.length > 0,
      })}>
      <strong className="tit_document">
        <div
          className="link_fold"
          onClick={() => {
            document.files.length > 0 && setOpen(!open)
          }}>
          {document.name} <em className="txt_num">{document.files.length}</em>
          <FileInput
            clearFiles
            accept=".jpg,.jpeg,.gif,.png,.tif,.hwp,.doc,.docx,.pdf"
            onFileChange={handleFileChange}>
            <Button
              disabled={!isEditable}
              size="small"
              loading={isUploading}
              onClick={e => e.preventDefault()}>
              파일업로드
            </Button>
          </FileInput>
        </div>
      </strong>
      <div className="list_file">
        {document.files.map(({ filename, path }) => (
          <div className="item_file" key={path}>
            <span className="file_name">{filename}</span>
            {isEditable && (
              <NoneAnchor
                className="link_del"
                onClick={() =>
                  handleFileDelete({
                    id: document.id,
                    path,
                  })
                }>
                <Icon name="del">삭제</Icon>
              </NoneAnchor>
            )}
          </div>
        ))}
        {error && (
          <div className="item_file ">
            <span className="file_name">
              <ErrorText error="업로드한 파일 용량을 확인 후 다시 시도하세요." />
            </span>
          </div>
        )}
      </div>
    </li>
  )
}

DocumentItem.propTypes = {
  document: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string,
    files: PropTypes.arrayOf(
      PropTypes.shape({
        path: PropTypes.string,
        filename: PropTypes.string,
      })
    ),
  }),
  isEditable: PropTypes.bool,
}
